<template>
  <div
    class="impact-coming-soon rounded-[12px] border border-[#E5E5E5] bg-[#FAFAFA] p-4"
    :data-testid="testId"
  >
    <div class="flex items-center justify-between gap-2 mb-2">
      <p v-if="title" class="text-[13px] font-semibold text-[var(--color-dark)] m-0">
        {{ title }}
      </p>
      <span
        class="text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full shrink-0"
        style="background-color: #FEFCE8; color: #EAB308"
      >
        {{ resolvedBadge }}
      </span>
    </div>
    <p class="text-[13px] text-[var(--color-disabled)] m-0 leading-relaxed">
      {{ message }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'ImpactComingSoonPanel',
  props: {
    title: { type: String, default: '' },
    message: { type: String, required: true },
    testId: { type: String, default: 'impact-coming-soon' },
    badgeLabel: { type: String, default: '' },
  },
  computed: {
    resolvedBadge() {
      return this.badgeLabel || this.$t('UserProjects.impactAnalysis.comingSoon.badge');
    },
  },
};
</script>
